import React from 'react';
import { Form, Input, Button } from 'antd';

import './Newpassword.css';
import Index from '../Index';

const Newpassword = () => {
    const mainLogo = '/assets/QA_Logo.svg';
    const [form] = Form.useForm();
    // Custom validator for password matching
    const confirmPasswordValidator = (rule, value, callback) => {
        const password = form.getFieldValue('password');
        if (value && password && value !== password) {
            callback('The password do not match.');
        } else {
            callback();
        }
    };

    return (
        <>
            <div className='newpass-container'>
                <Index />
                <div className='newpassword-main'>
                    <div className='newpassword-div'>
                        <div className='center-img'>
                            <img
                                src={mainLogo}
                                alt=''
                                className='centered-image'
                            />
                        </div>

                        <p className='newpassword_text'>New Password</p>

                        <Form
                            name='newpassport'
                            form={form}
                            initialValues={{
                                remember: true,
                                password: '',
                                confirmNewPassword: '',
                            }}
                            // onFinish={onFinish}
                            className='newpassword-class-form'>
                            <label>Enter new password</label>
                            <Form.Item
                                name='password'
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please enter your new password!',
                                    },
                                    {
                                        min: 8,
                                        message:
                                            'Password must be at least 8 characters long',
                                    },
                                ]}>
                                <Input.Password placeholder=' Enter your new password' />
                            </Form.Item>

                            <label>Confirm password</label>
                            <Form.Item
                                name='confirmNewPassword'
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please enter your confirm password!',
                                    },
                                    {
                                        validator: confirmPasswordValidator,
                                    },
                                    // {
                                    //   min: 8,
                                    //   message: "Password must be at least 8 characters long",
                                    // },
                                ]}>
                                <Input.Password placeholder=' Enter your confirm password' />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    style={{ marginTop: '20px' }}
                                    type='primary'
                                    htmlType='submit'
                                    block
                                    className='submit_login-btn'>
                                    Create
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Newpassword;
